import { instance } from '../apiBase/instance';

export type UserLoginPayload = {
    email: string;
    password: string;
};

export type PrivyLoginPayload = {
    accessToken: string;
};

export type UserRegisterPayload = {
    displayName: string;
    email: string;
    password: string;
};

export type VerifyOtpPayload = {
    email: string;
    otp: string;
};

export type ForgotPasswordPayload = {
    email: string;
};

export type ResetPasswordPayload = {
    email: string;
    otp: string;
    password: string;
};

export type UserProfile = {
    [key: string]: unknown;
};

export const AppAuth = {
    UserLogin(params: UserLoginPayload) {
        return instance.post('user/login', params);
    },
    UserLoginWithPrivy(params: PrivyLoginPayload) {
        return instance.post('user/login', params);
    },
    UserLoginWithGoogle(params: PrivyLoginPayload) {
        return instance.post('user/login/google', params);
    },
    UserRegister(params: UserRegisterPayload) {
        return instance.post('user/register', params);
    },
    SendOtpRegister(params: VerifyOtpPayload) {
        return instance.post('user/verify-otp', params);
    },
    ForgotPassword(params: ForgotPasswordPayload) {
        return instance.post('user/forgot-password', params);
    },
    ResetPassword(params: ResetPasswordPayload) {
        return instance.post('user/reset-password', params);
    },
    GetUserProfile() {
        return instance.get<UserProfile>('user/me');
    },
};
